<template>
    <div style="padding-top:10px;padding-bottom: 10px;">
        <span v-for="fixedPhrase in fixedPhraseList">
            <span v-if="fixedPhrase.categoryValue === CONSTANT.FIXED_PHRASE_CATEGORY_TEXT">
                <span v-t="'message.item_fixed_phrase_text'"/>：
                {{ fixedPhrase.phraseValue }}
            </span>
            <span v-else-if="fixedPhrase.categoryValue === CONSTANT.FIXED_PHRASE_CATEGORY_SOUND">
                <span v-t="'message.item_fixed_phrase_sound'"/>：
                <span v-if="fixedPhrase.phraseValue === 1" v-t="'message.item_sound1'"></span>
                <span v-else v-t="'message.item_sound2'"></span>
            </span>
            <span v-else>
                <span v-t="'message.item_fixed_phrase_melody'"/>：
                {{ fixedPhrase.phraseValue }}
            </span>
            <br>
        </span>
    </div>
</template>

<script>
import constants from '../../../constants.js';

export default {
    data() {
        return {
            CONSTANT: {
                FIXED_PHRASE_CATEGORY_TEXT: constants.FIXED_PHRASE_CATEGORY_TEXT,
                FIXED_PHRASE_CATEGORY_SOUND: constants.FIXED_PHRASE_CATEGORY_SOUND,
                FIXED_PHRASE_CATEGORY_MELODY: constants.FIXED_PHRASE_CATEGORY_MELODY,
            },
        };
    },
    methods: {
    },
    components: {
    },
    created: function() {
    },
    watch: {
    },
    props: [ 'fixedPhraseList' ]
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
